import { combineReducers } from "redux";
import customiseReducer from "./customise/customiseReducer";
import LoginReducer from "./Login/LoginReducer";
import SettingsReducer from "./Settings/SettingsReducer";
import ApprovalReducer from "./Approval/ApprovalReducer";
import EmailReducer from './Email/EmailReducer';
import EmployeeAdvanceReducer from "./EmployeeAdvance/EmployeeAdvanceReducer";
import CategoryReducer from "./CategoryList/CategoryReducer";
import ExpenseClaimReducer from "./ExpenseClaim/ExpenseClaimReducer";
import ExpeseSettingsReducer from "./ExpenseSettings/ExpeseSettingsReducer";
import ReportsReducer from './Reports/ReportsReducer';
import ReconcileReducer from "./AdvanceReconcile/ReconcileReducer";
import AdvanceRefundReducer from "./AdvanceRefund/RefundReducer";
import PolicyReducer from "./Policies/PolicyReducer";
import UserMasterReducer from "./UserMaster/UserMasterReducer";
import TripReducer from "./Trip/TripsReducer";
import TravelAdvanceReducer from "./TravelAdvance/TravelAdvanceReducer";
import UserProfileReducer from "./UserProfile/UserProfileReducer";

const rootReducer = combineReducers({
  customise: customiseReducer,
  login: LoginReducer,
  settings: SettingsReducer,
  approval: ApprovalReducer,
  email: EmailReducer,
  EmployeeAdvance: EmployeeAdvanceReducer,
  Category: CategoryReducer,
  ExpenseClaim: ExpenseClaimReducer,
  expenseSettings: ExpeseSettingsReducer,
  Reports: ReportsReducer,
  Reconcile: ReconcileReducer,
  Refund: AdvanceRefundReducer,
  Policy: PolicyReducer,
  UserMaster: UserMasterReducer,
  Trip: TripReducer,
  TravelAdvance: TravelAdvanceReducer,
  UserProfile: UserProfileReducer
});

export default rootReducer;